import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{category-link @result link=false allowUncategorized=true}}",{ moduleName: "discourse/components/search-menu/results/type/category.hbs" })